import { useContext } from "react";
import { Button, ButtonProps } from "@mui/material";
import ConfigurationsContext from "context/configurations/ConfigurationsContext";
import SupportIcon from "./assets/Support-Icon.svg";

interface SupportCTAProps extends Omit<ButtonProps, "href"> {
	href: string;
}

const SupportCTA = ({ href, sx, children = "SUPPORT", ...props }: SupportCTAProps) => {
	const { configurationsData } = useContext(ConfigurationsContext);
	const isSupportLinkEnabled = configurationsData?.featureFlags?.orderPageSupportLinkEnabled === true;

	if (!isSupportLinkEnabled) {
		return null;
	}

	return (
		<Button
			variant="contained"
			component="a"
			href={href}
			target="_blank"
			rel="noopener noreferrer"
			startIcon={<SupportIcon />}
			sx={{
				backgroundColor: "var(--cwg-blue-900)",
				fontSize: "13px",
				fontWeight: "var(--font-weight-medium)",
				letterSpacing: "var(--letter-spacing-10)",
				lineHeight: "1.5rem",
				"&:hover": {
					backgroundColor: "var(--cwg-blue-800)"
				},
				...sx
			}}
			{...props}
		>
			{children}
		</Button>
	);
};

export default SupportCTA;
